import React from "react";
import { FaBuilding, FaBriefcase } from "react-icons/fa";
import card2Bg from "../../../assets/Bulk/Card2/card2.svg";
import card3Bg from "../../../assets/Bulk/Card2/card3.svg";
import card1Bg from "../../../assets/Exactness/Header/Bg.svg";
import Line from "../../../assets/line2.svg";
import { Zap } from "lucide-react";

const cardData = [
  {
    title: "Automate Email Extraction with Zapier",
    description:
      "Integrate ExactEmails with Zapier to automatically extract emails from LinkedIn profiles and send them to your favorite apps.",
    icon: <Zap className="text-[#FFBA08] text-xl" />,
    bgImage: card1Bg,
    color: "text-[#FFBA08]",
    bgcolor: "bg-[#FFF5D6]",
    border: "border-[#FFD966]",
  },
  {
    title: "Sync Company Emails Seamlessly",
    description:
      "Use Zapier to connect ExactEmails with CRMs and tools like HubSpot or Google Sheets, ensuring real-time email data synchronization.",
    icon: <FaBuilding className="text-[#F88DA0] text-xl" />,
    bgImage: card2Bg,
    color: "text-[#F88DA0]",
    bgcolor: "bg-[#FDEBED]",
    border: "border-[#F9AFBB]",
  },
  {
    title: "Find & Automate Decision Maker Outreach",
    description:
      "Extract decision-maker emails and trigger automated workflows with Zapier, sending data to email campaigns, Slack, or your CRM.",
    icon: <FaBriefcase className="text-[#64D1AE] text-xl" />,
    bgImage: card3Bg,
    color: "text-[#64D1AE]",
    bgcolor: "bg-[#EBFBF4]",
    border: "border-[#98E2C9]",
  },
];

const Cards = () => {
  return (
    <>
      <h2 className="text-3xl bg-gray-50 pt-6 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold text-center md:pt-16">
        Automate your outreach,
      </h2>
      <h2 className="text-3xl bg-gray-50 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold text-center">
        No{" "}
        <span className="relative inline-block">
          coding
          <img
            src={Line}
            alt="Underline decoration"
            className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
          />
        </span>{" "}
        required
      </h2>
      <div className="grid gap-6 py-6 lg:py-20 bg-gray-50 sm:grid-cols-2 lg:grid-cols-3 p-6">
        {cardData.map((card, index) => (
          <div
            key={index}
            className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left "
            style={{
              backgroundImage: `url(${card.bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-white opacity-5"></div>
            <div className="relative z-10 flex flex-col h-full">
              <div
                className={`my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 ${card.border} border ${card.bgcolor}`}
              >
                <div className="my-4">{card.icon}</div>
              </div>
              <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
              <p className="text-gray-600 mb-4">{card.description}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Cards;
